import { render, staticRenderFns } from "./UpdateDeliv.vue?vue&type=template&id=a66846a2&lang=pug"
import script from "./UpdateDeliv.vue?vue&type=script&lang=js"
export * from "./UpdateDeliv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports